import { lerErroDaApi } from './validacaoUsuario';

export async function wrapSafelyAndReturnBool(callback: (...args: unknown[]) => Promise<unknown>) {
    try {
        const result = await callback(); // eslint-disable-line @typescript-eslint/no-unsafe-assignment
        console.log(result);
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
}

/** Resultado de uma ação que pode falhar, com a mensagem real da API quando falha. */
export type ResultadoAcao = { ok: true } | { ok: false; mensagem: string };

/**
 * Igual a `wrapSafelyAndReturnBool`, mas devolve a mensagem do erro (o corpo da
 * API lido por `lerErroDaApi`) em vez de só `false` — para o toast mostrar o motivo.
 */
export async function wrapSafelyAndReturnError(callback: () => Promise<unknown>, padrao = 'Não foi possível concluir a ação.'): Promise<ResultadoAcao> {
    try {
        await callback();
        return { ok: true };
    } catch (e) {
        console.error(e);
        return { ok: false, mensagem: lerErroDaApi(e, padrao).mensagem };
    }
}
